module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?> <svg version=1.2 baseProfile=tiny id=center xmlns=http://www.w3.org/2000/svg x=0px y=0px viewBox=\"0 0 122 122\" xml:space=preserve> <g> <circle id=circle fill=none stroke=#000000 stroke-width=2 stroke-miterlimit=10 cx=60.8 cy=61 r=34 /> <g id=center> <path d=M50.2,72c0,1.1,0.9,2,2,2h4c1.1,0,2-0.9,2-2V50c0-1.1-0.9-2-2-2h-4c-1.1,0-2,0.9-2,2V72z /> <path d=M63.2,72c0,1.1,0.9,2,2,2h4c1.1,0,2-0.9,2-2V50c0-1.1-0.9-2-2-2h-4c-1.1,0-2,0.9-2,2V72z /> </g> </g> </svg> ";


//////////////////
// WEBPACK FOOTER
// ./public/web/images/pausa_krug-01.svg
// module id = 9Fn3
// module chunks = 3 4